// extracted by mini-css-extract-plugin
export default {"visible":"Header_visible__5yjBe","invisible":"Header_invisible__aM3D7"};